module.exports = "/_next/static/videos/game2-intro-a7d829d327580dfb5aa22948d46a680a.mp4";